import gsap from 'gsap';
import { AmbientLight, Group } from 'three';

import {
  THUNDERSTORM_PERIL_INITIAL_POSITION,
  WATER_PERIL_INITIAL_POSITION,
} from './PerilsScene';

export const AMBIENT_LIGHT_MAX_INTENSITY = 3;

export const revealWater = (group: Group) =>
  gsap.timeline().to(group.position, {
    y: 0,
    duration: 1.5,
    // ease: ''
  });

export const hideWater = (group: Group) =>
  gsap.timeline().to(group.position, {
    ...WATER_PERIL_INITIAL_POSITION,
    duration: 1.5,
    // ease: 'power1.out',
  });

export const revealThunderstorm = (thunderstorm: Group) =>
  gsap.timeline().to(thunderstorm.position, {
    y: 0,
    duration: 0.3,
    ease: 'power1.in',
  });

export const hideThunderstorm = (thunderstorm: Group) =>
  gsap.timeline().to(thunderstorm.position, {
    ...THUNDERSTORM_PERIL_INITIAL_POSITION,
    duration: 0.3,
    ease: 'power1.in',
  });

export const revealAmbientLight = (light: AmbientLight) =>
  gsap.timeline().to(light, {
    intensity: 3,
    duration: 1,
    ease: 'power1.in',
  });

export const hideAmbientLight = (light: AmbientLight) =>
  gsap.timeline().to(light, {
    intensity: 0,
    duration: 1,
    ease: 'power1.out',
  });
